const halves = ["1stHalf", "2ndHalf"];

const forAgainstTypes = [
	{suffix: "For", label: "A favore"},
	{suffix: "Against", label: "Contro"},
];

const possessionContexts = [
	{suffix: "OwnHalf", label: "Metà campo nostra"},
	{suffix: "OpponentHalf", label: "Metà campo avversaria"},
];

export const MATCH_ADVANCED_FOR_AGAINST_SECTIONS = [
	{
		title: "Finalizzazione",
		metrics: [
			{key: "scoringChances", label: "Occasioni da gol"},
			{key: "penalty", label: "Rigori"},
			{key: "shotsInsideBox", label: "Tiri in area"},
			{key: "shotsOutsideBox", label: "Tiri fuori area"},
		],
	},
	{
		title: "Palle inattive",
		metrics: [
			{key: "centralFreeKicks", label: "Punizioni centrali"},
			{key: "lateralFreeKicks", label: "Punizioni laterali"},
			{key: "corners", label: "Calci d'angolo"},
			{key: "crosses", label: "Cross"},
		],
	},
	{
		title: "Azioni e xG",
		metrics: [
			{key: "promisingActions", label: "Azioni promettenti"},
			{key: "xg", label: "xG", decimals: 2},
		],
	},
];

export const MATCH_ADVANCED_CONTEXT_SECTIONS = [
	{
		title: "Perdite palla",
		metrics: [
			{
				key: "ballLosses",
				label: "Perdite palla",
				contexts: possessionContexts,
			},
		],
	},
	{
		title: "Possesso (secondi)",
		metrics: [
			{
				key: "possessionSeconds",
				label: "Secondi in possesso",
				contexts: possessionContexts,
			},
		],
	},
	{
		title: "Possesso (%)",
		metrics: [
			{
				key: "possessionPercentage",
				label: "Percentuale possesso",
				contexts: possessionContexts,
				decimals: 1,
				suffix: "%",
			},
		],
	},
];

export const MATCH_ADVANCED_SIMPLE_SECTIONS = [
	{
		title: "Indicatori squadra",
		metrics: [
			{key: "ppdaFor", label: "PPDA", decimals: 2},
			{key: "defensiveAnticipations", label: "Anticipi difensivi"},
			{key: "groundDuelsWon", label: "Duelli a terra vinti"},
			{key: "aerialDuelsWon", label: "Duelli aerei vinti"},
			{key: "tacklesWon", label: "Tackle vinti"},
			{key: "secondBallsWon", label: "Secondi palloni vinti"},
		],
	},
	{
		title: "Statistiche portiere",
		metrics: [
			{key: "gkDefensiveAnticipations", label: "Anticipi difensivi GK"},
			{key: "gkGroundDuelsWon", label: "Duelli a terra vinti GK"},
			{key: "gkAerialDuelsWon", label: "Duelli aerei vinti GK"},
			{key: "gkTacklesWon", label: "Tackle vinti GK"},
			{key: "gkSecondBallsWon", label: "Secondi palloni vinti GK"},
		],
	},
];

const fieldSet = new Set();

MATCH_ADVANCED_FOR_AGAINST_SECTIONS.forEach((section) => {
	section.metrics.forEach((metric) => {
		forAgainstTypes.forEach((type) => {
			halves.forEach((half) => {
				fieldSet.add(`${metric.key}${type.suffix}${half}`);
			});
		});
	});
});

MATCH_ADVANCED_CONTEXT_SECTIONS.forEach((section) => {
	section.metrics.forEach((metric) => {
		metric.contexts.forEach((context) => {
			halves.forEach((half) => {
				fieldSet.add(`${metric.key}${context.suffix}${half}`);
			});
		});
	});
});

MATCH_ADVANCED_SIMPLE_SECTIONS.forEach((section) => {
	section.metrics.forEach((metric) => {
		halves.forEach((half) => {
			fieldSet.add(`${metric.key}${half}`);
		});
	});
});

export const MATCH_ADVANCED_FIELDS = Array.from(fieldSet);

export const createAdvancedStatsInitialValues = (data = {}) => {
	return MATCH_ADVANCED_FIELDS.reduce((acc, field) => {
		const value = data[field];
		acc[field] =
			value === null || value === undefined || Number.isNaN(value) ? "" : value;
		return acc;
	}, {});
};

export const buildAdvancedStatsPayload = (values) => {
	const payload = {};
	MATCH_ADVANCED_FIELDS.forEach((field) => {
		const raw = values[field];
		payload[field] =
			raw === "" || raw === null || raw === undefined ? null : Number(raw);
	});
	return payload;
};

export const formatAdvancedStatValue = (value, decimals, suffix) => {
	if (value === null || value === undefined) {
		return "---";
	}
	let formatted =
		decimals !== undefined ? Number(value).toFixed(decimals) : Number(value);
	if (Number.isNaN(formatted)) {
		formatted = "--";
	}
	return suffix ? `${formatted}${suffix}` : formatted;
};

export const FOR_AGAINST_TYPES = forAgainstTypes;
export const MATCH_HALVES = halves;

